













































































































































import Vue, { PropType } from "vue";
import _ from "lodash";
export default Vue.extend({
  data() {
    return {
      loading: false,
    };
  },
  props: {
    asChild: {
      type: Boolean,
      default: false,
    },
    executionSuspended: {
      type: Boolean,
      default: false,
    },
    forms: {
      type: Array as PropType<string[]>,
      default: () => [] as string[],
    },
    confirmLabel: {
      type: String,
      default: "次へ",
    },
    execLabel: {
      type: String,
      default: "送信",
    },
    backLabel: {
      type: String,
      default: "修正",
    },
    cancelLabel: {
      type: String,
      default: "キャンセル",
    },
    input: {
      type: Object as PropType<Record<string, string | unknown>>,
      default(): Record<string, string | unknown> {
        return {};
      },
    },
    errors: {
      type: Object as PropType<Record<string, string | unknown>>,
      default(): Record<string, string | unknown> {
        return {};
      },
    },
    frozen: {
      default: false,
    },
    staticForm: {
      default: false,
    },
    isLoading: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    phase: {
      type: String,
      default: "input",
    },
    skipConfirmation: {
      type: Boolean,
      default: false,
    },
    hasCancellation: {
      type: Boolean,
      default: false,
    },
    hasExecution: {
      type: Boolean,
      default: true,
    },
    scrollBehavior: {
      type: Boolean,
      default: true,
    },
    appearance: {
      default: "standard",
    },
  },
  methods: {
    async confirm() {
      // this.loading = true;
      this.$emit("confirm");
    },
    cancel() {
      this.$emit("cancel");
    },
    exec() {
      this.$emit("exec");
    },
    async back() {
      this.$emit("update:phase", "input");
    },
  },
  watch: {
    phase() {
      if (this.scrollBehavior) {
        document.body.scrollIntoView({
          behavior: "auto",
          block: "start",
        });
        // this.loading = false;
      }
    },
  },
  provide() {
    return {
      $formVars: () => {
        return {
          input: this.input,
          errors: this.errors,
          phase: this.frozen ? "confirm" : this.phase,
          isLoading: this.isLoading,
          hasError: (path: string) => {
            return _.has(this.errors, path);
          },
          static: this.staticForm,
          parts: {
            requiredIcon: (this.$refs.requiredIcon as any).innerHTML,
          },
        };
      },
    };
  },
  computed: {
    hasErrors(): boolean {
      return !_.isEmpty(this.errors);
    },
    isLoadingActive(): boolean {
      return this.isLoading || this.loading;
    },
    noButtons(): boolean {
      return this.$props.asChild;
    },
  },
});
